export default "__VITE_ASSET__C57JNhOc__"